module.exports = __webpack_public_path__ + "img/gongzhonghao.e7558d45.png";